import { MarketStatus } from '@sportspredict/shared';

export const marketStatusOrder = [MarketStatus.Open, MarketStatus.Closed, MarketStatus.Settled];
export const MV_STATUS_INIT = 'initial';
export const MV_STATUS_INCR = 'increased';
export const MV_STATUS_DECR = 'decreased';

export const MARKET_ABOUT_TO_CLOSE_MS = 3 * 60 * 1000;

export const INITIAL_NEW_SECOND_CHANCE_MARKET = {
	question: '',
	context: '',
	lobby_id: '',
	priority: 0,
	min_value: 0,
	max_value: 100,
	score: 0,
};
